import brand_traits from "../../assets/json/parameters/BrandTraits.json"
import classes from "./SeedCalculator.module.css"
import { ability_order } from "../../Utils"

export function next(num) {
    num ^= num << 13
    num ^= num >>> 17
    num ^= num << 5
    return num >>> 0
}

export function prev(num) {
    num ^= num << 5
    num ^= num << 10
    num ^= num << 20
    num ^= num >>> 17
    num ^= num << 13
    num ^= num << 26
    return num
}

function getBrandedAbility(roll, brand) {
    for (let elem of ability_order) {
        if (brand_traits.Traits[brand].UnusualGearSkill === elem) {
            roll -= brand_traits.SkillEasilyToGetParam[0]
        } else if (brand_traits.Traits[brand].UsualGearSkill === elem) {
            roll -= brand_traits.SkillEasilyToGetParam[2]
        } else {
            roll -= brand_traits.SkillEasilyToGetParam[1]
        }
        if (roll < 0) return elem
    }
}

function getBrandedAbility_exclude(roll, brand, exclude) {
    for (let elem of ability_order) {
        if (elem === exclude) continue
        if (brand_traits.Traits[brand].UnusualGearSkill === elem) {
            roll -= brand_traits.SkillEasilyToGetParam[0]
        } else if (brand_traits.Traits[brand].UsualGearSkill === elem) {
            roll -= brand_traits.SkillEasilyToGetParam[2]
        } else {
            roll -= brand_traits.SkillEasilyToGetParam[1]
        }
        if (roll < 0) return elem
    }
}

function mod_num(a, n) {
    return ((a % n) + n) % n
}

function get_max_num(brand) {
    let max_num = ability_order.length * brand_traits.SkillEasilyToGetParam[1]
    if (brand_traits.Traits[brand].UnusualGearSkill !== "None") {
        max_num =
            (ability_order.length - 2) * brand_traits.SkillEasilyToGetParam[1] +
            brand_traits.SkillEasilyToGetParam[0] +
            brand_traits.SkillEasilyToGetParam[2]
    }
    return max_num
}

function get_max_num_exclude(brand, exclude) {
    let max_num = ability_order.length * brand_traits.SkillEasilyToGetParam[1]
    if (brand_traits.Traits[brand].UnusualGearSkill !== "None") {
        max_num =
            (ability_order.length - 2) * brand_traits.SkillEasilyToGetParam[1] +
            brand_traits.SkillEasilyToGetParam[0] +
            brand_traits.SkillEasilyToGetParam[2]
    }
    if (brand_traits.Traits[brand].UnusualGearSkill === exclude) {
        max_num -= brand_traits.SkillEasilyToGetParam[0]
    } else if (brand_traits.Traits[brand].UsualGearSkill === exclude) {
        max_num -= brand_traits.SkillEasilyToGetParam[2]
    } else {
        max_num -= brand_traits.SkillEasilyToGetParam[1]
    }
    return max_num
}

export function get_roll(seed, brand, drink) {
    let max_num = get_max_num(brand)
    seed = next(seed)
    if (drink !== "None") {
        if (mod_num(seed >>> 0, 0x64) <= 0x1d) {
            return [seed, drink, true]
        } else {
            seed = next(seed)
            max_num = get_max_num_exclude(brand, drink)
            let ability_roll = mod_num(seed >>> 0, max_num)
            return [seed, getBrandedAbility_exclude(ability_roll, brand, drink), false]
        }
    } else {
        let ability_roll = mod_num(seed >>> 0, max_num)
        return [seed, getBrandedAbility(ability_roll, brand), false]
    }
}

function getData(seed, idx, brand, drink, t) {
    const [new_seed, ability, isDrink] = get_roll(seed, brand, drink)
    const ability_str = t("translation:CommonMsg.Gear.GearPowerName." + ability)
    const url = `https://leanny.github.io/splat3/images/skill/${ability}.png`
    return [
        new_seed >>> 0,
        {
            Idx: idx,
            Ability: (
                <>
                    <img src={url} width="32" alt={ability_str} className={classes.Ability} />
                    <span className={classes.Gap}>
                        {ability_str}
                        {isDrink ? " (" + t("translation:LayoutMsg.Lobby_Shop_00.T_Drink_00") + ")" : ""}
                    </span>
                </>
            ),
            Seed: `0x${(new_seed >>> 0).toString(16)}`,
            IsDrink: isDrink,
        },
    ]
}

export function advanceFrame(seed, frame) {
    for (let i = 0; i > frame; i--) {
        seed = prev(seed)
    }
    for (let i = 0; i < frame; i++) {
        seed = next(seed)
    }
    return seed
}

const res = (seed, startFrame, numOfFrames, brand, drink, t) => {
    let startSeed = parseInt(seed.substring(2), 16)
    seed = advanceFrame(startSeed, startFrame)
    let res = []
    for (let counter = startFrame; counter < startFrame + numOfFrames; counter++) {
        const [new_seed, result] = getData(seed, counter, brand, drink, t)
        res.push(result)
        seed = new_seed
    }

    return res
}

export default res
